// utilities
import api from '@/utilities/api'
export const getItineraries = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/itineraries',
    payload,
    success (response) {
      commit('setItineraries', response.data)
    }
  })
}
export const getCampsiteBookings = ({ commit, dispatch }, payload) => {
  // getItineraryCampsiteBookings
  return api.request({
    method: 'get',
    endpoint: 'private/itineraries/' + payload.itineraryID + '/campsiteBookings',
    payload,
    success (response) {
      commit('setCampsiteBookings', { ...payload, campsiteBookings: response.data })
    }
  })
}
export const deleteItineraries = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/itineraries',
    payload,
    success (response) {
      dispatch('getItineraries')
    }
  })
}
export const updateItinerary = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/itineraries/' + payload.itineraryID,
    payload,
    success (response) {
      dispatch('getItineraries')
    }
  })
}
export const getItinerary = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/itineraries/' + payload.itineraryID,
    success (response) {
      commit('setItinerary', response.data)
    }
  })
}
export const updateCampsiteBookingParties = ({ commit, dispatch }, payload) => {
  // batch
  return api.request({
    method: 'put',
    endpoint: 'private/campsiteBookings/parties',
    payload,
    success (response) {
      dispatch('cart/getCart', {}, { root: true })
    }
  })
}
export const updateCampsiteBookingItinerary = ({ commit, dispatch }, payload) => {
  // batch
  return api.request({
    method: 'put',
    endpoint: 'private/campsiteBookings/itinerary',
    payload
  })
}
export const deleteCampsiteBookings = ({ commit, dispatch }, payload) => {
  // batch
  return api.request({
    method: 'delete',
    endpoint: 'private/campsiteBookings',
    payload,
    success (response) {
      // reload stuff
    }
  })
}
